import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { StudentEvaluationVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const educationalAdvisorRetrieveEvaluationsGroupedByStudent = createAsyncThunk<
  StudentEvaluationVM[],
  void,
  { extra: Partial<Dependencies> }
>(
  "evaluationsGroupedByStudents/educationalAdvisorRetrieveEvaluationsGroupedByStudent",
  async (_: void, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.getEvaluationsGroupedByStudent();
  },
);

export const resetEducationalAdvisorRetrieveEvaluationsGroupedByStudent = createAction(
  "evaluationsGroupedByStudents/resetEducationalAdvisorRetrieveEvaluationsGroupedByStudent",
);
